import React from 'react';
import { Element } from './CompanyImage.styles';
import Image from '@/providers/Image';
import useImagePulse from '@/components/media/imagePulseHook';
import { mediaBlurDataUrl, mediaUrlCdn } from '@/utils/media';

type ImageProps = {
  media?: MediaObjType;
};

const CompanyImage = ({ media }: ImageProps) => {
  const { className, containerRef, handleOnCompleted } = useImagePulse();
  return (
    <Element className={className} ref={containerRef}>
      <Image
        src={mediaUrlCdn({ media })}
        alt={media?.title || 'Logo cia'}
        placeholder={mediaBlurDataUrl({ media })}
        fadeInOnBlur
        handleOnCompleted={handleOnCompleted}
        // fill
        width={216}
        height={139}
      />
    </Element>
  );
};

export default CompanyImage;
